import { ClientListResponseSchema, ClientSchema, ClientWriteResponseSchema, ClientWipTotalResponseSchema, DeleteClientResponseSchema, ListClientEmailsResponseSchema, ClientEmailResponseSchema, UpsertClientBusinessEntityResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function listClients(accountId, options) {
    const params = new URLSearchParams();
    if (options?.archivedOnly)
        params.set('archivedOnly', 'true');
    if (options?.includeArchived)
        params.set('includeArchived', 'true');
    if (options?.cursor)
        params.set('cursor', options.cursor);
    if (options?.limit !== undefined)
        params.set('limit', String(options.limit));
    if (options?.ids && options.ids.length > 0) {
        for (const id of options.ids)
            params.append('ids', id);
    }
    if (options?.search)
        params.set('search', options.search);
    if (options?.sortBy)
        params.set('sortBy', options.sortBy);
    if (options?.sortDirection)
        params.set('sortDirection', options.sortDirection);
    if (options?.status)
        params.set('status', options.status);
    const qs = params.toString();
    return api(`/accounts/${accountId}/clients${qs ? `?${qs}` : ''}`, ClientListResponseSchema);
}
export function getClient(accountId, clientId) {
    return api(`/accounts/${accountId}/clients/${clientId}`, ClientSchema);
}
export function getClientWipTotal(accountId, clientId) {
    return api(`/accounts/${accountId}/clients/${clientId}/wip-total`, ClientWipTotalResponseSchema);
}
/**
 * Creates a client. A caller that retries one logical create (an uncertain response) passes the
 * same `idempotencyKey` each time; otherwise a fresh key is minted per call.
 */
export function createClient(accountId, input) {
    return api(`/accounts/${accountId}/clients`, ClientWriteResponseSchema, {
        method: 'POST',
        body: { ...input, idempotencyKey: input.idempotencyKey ?? crypto.randomUUID() },
    });
}
export function updateClient(accountId, clientId, input) {
    return api(`/accounts/${accountId}/clients/${clientId}`, ClientWriteResponseSchema, {
        method: 'PATCH',
        body: input,
    });
}
export function archiveClient(accountId, clientId) {
    return api(`/accounts/${accountId}/clients/${clientId}`, DeleteClientResponseSchema, {
        method: 'DELETE',
    });
}
export function upsertClientBusinessEntity(accountId, clientId, input) {
    return api(`/accounts/${accountId}/clients/${clientId}/business-entity`, UpsertClientBusinessEntityResponseSchema, {
        method: 'PUT',
        body: input,
    });
}
export function listClientEmails(accountId, clientId) {
    return api(`/accounts/${accountId}/clients/${clientId}/emails`, ListClientEmailsResponseSchema);
}
export function addClientEmail(accountId, clientId, body) {
    return api(`/accounts/${accountId}/clients/${clientId}/emails`, ClientEmailResponseSchema, {
        method: 'POST',
        body,
    });
}
export function updateClientEmail(accountId, clientId, emailId) {
    return api(`/accounts/${accountId}/clients/${clientId}/emails/${emailId}`, ClientEmailResponseSchema, {
        method: 'PATCH',
        body: { isPrimary: true },
    });
}
export function updateClientEmailName(accountId, clientId, emailId, name) {
    return api(`/accounts/${accountId}/clients/${clientId}/emails/${emailId}/name`, ClientEmailResponseSchema, {
        method: 'PATCH',
        body: { name },
    });
}
export function deleteClientEmail(accountId, clientId, emailId) {
    return api(`/accounts/${accountId}/clients/${clientId}/emails/${emailId}`, DeleteClientResponseSchema, {
        method: 'DELETE',
        // No body - DELETE requests must not include Content-Type: application/json
    });
}
